import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './white_header.less'

class WhiteHeader extends React.Component {
  static propTypes = {
    children: PropTypes.any,
  }

  state = {
    fixedDivHeight: 'auto',
  }

  componentDidMount() {
    this.handleResize() // in order to have the fixed div height and set it to the static div
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    const fixedDivHeight = (this.fixedDiv && this.fixedDiv.offsetHeight) || 0
    this.setState({ fixedDivHeight })
  }

  render() {
    return (
      <div
        data-fixed="true"
        styleName={'campaign-white-header-fixed'}
        ref={fixedDiv => {
          this.fixedDiv = fixedDiv
        }}
      >
        <div>{this.props.children}</div>
      </div>
    )
  }
}

export default cssModules(WhiteHeader, styles)
